import SsoDialogType from '../store/schema/enums/SsoDialogType';
import store from '../store/store';
import { createVisibleSsoDialog } from '../store/schema/interfaces/ActiveSsoDialog';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('showSsoDialog', function(
    controlId: string,
    type: SsoDialogType,
    authChallenge: string
) {
    store.activeSsoDialog = createVisibleSsoDialog(controlId, type, authChallenge);
});
